import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  connected: false,
  lastError: null,
  queues: {
    counts: {},
    metrics: null
  }
}

export const realtimeSlice = createSlice({
  name: 'realtime',
  initialState,
  reducers: {
    setConnected: (state, action) => {
      state.connected = !!action.payload?.connected
      if (action.payload?.error !== undefined) {
        state.lastError = action.payload.error
      }
    },
    setQueueCounts: (state, action) => {
      const { name, counts } = action.payload || {}
      if (!name) return
      state.queues.counts[name] = counts
    },
    setQueuesMetrics: (state, action) => {
      state.queues.metrics = action.payload
    },
    resetQueues: (state) => {
      state.queues.counts = {}
      state.queues.metrics = null
    }
  }
})

export const {
  setConnected,
  setQueueCounts,
  setQueuesMetrics,
  resetQueues
} = realtimeSlice.actions

export default realtimeSlice.reducer
